import store from '@/store';

export default {
  data() {
    return {
      selected: '',
    };
  },
  props: ['addresses'],
  methods: {
    chooseAddress() {
      this.$emit('insert', this.selected);
      this.selected = '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/addressSelector/addressSelector.js